// extracted by mini-css-extract-plugin
export default {"hero":"src-modules-dashboard-components-Hero-style__hero_CefH8","heading":"src-modules-dashboard-components-Hero-style__heading_HZfw1"};